import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { getTicketsLoading, getTotalOpenTickets, State } from 'src/app/store';

@Component({
  selector: 'app-widget-tickets',
  templateUrl: './widget-tickets.component.html',
  styleUrls: ['../widgets.scss', './widget-tickets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WidgetTicketsComponent {
  private readonly store = inject(Store<State>);

  public readonly totalOpenTickets$ = this.store.select(getTotalOpenTickets);

  public readonly isLoading$ = this.store.select(getTicketsLoading);
}
